import * as actions from '../../actions/actionTypes';

const initialState = false;

export default function fetching(state = initialState, action) {
  switch (action.type) {
    case actions.SET_SCHEDULES_FETCHING:
      return true;
    case actions.SET_SCHEDULES:
      return false;
    case actions.SET_SCHEDULES_ERROR:
      return false;
    default:
      return state;
  }
}
